import { LoansProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";

export const LOAN_TYPES = ["mortgage", "consumerLoan"] as const;

export type LoanType = (typeof LOAN_TYPES)[number];

export const LOAN_PRODUCT_CATEGORIES: Record<
	LoanType,
	LoansProductCategoryKeyEnum
> = {
	mortgage: LoansProductCategoryKeyEnum.HousingLoans,
	consumerLoan: LoansProductCategoryKeyEnum.ConsumerLoans,
};

const LOAN_TYPES_WITH_FIXATION: LoanType[] = ["mortgage"];

export const hasLoanFixation = (loanType: LoanType) =>
	LOAN_TYPES_WITH_FIXATION.includes(loanType);
